module.exports = __webpack_public_path__ + "static/img/app-store-fr.d66ffc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero/app-store-fr.png
// module id = 83
// module chunks = 0